import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Header } from "../components/headerComponent";
import styles from "../styles/dashboardPage.module.css";

export const Dashboard = ({ children, header }: {
  children: React.ReactNode, header?: string
}) => {
  const { businessType, activeBusiness } = useSelector((state: any) => state.business);
  const location = useLocation();

  // const url = new URL(window.location.href);
  // const host = url.host;

  useEffect(() => {
    console.log("dashboard location:", location.pathname);
  }, []);

  return (
    <div>
      <Header />
      {header && <div
        className={styles.maxWidth}
        style={{
          borderRadius: 15,
          padding: 5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          marginBottom: 5,
        }}
      >
        <h3 className={styles.activeAnalyticsHeader}>{header}</h3>
      </div>}
      <div
        className={styles.maxWidth}
        style={{
          background: "#fff",
          borderRadius: 20,
          padding: 20,
        }}
      >
        {children}
      </div>
    </div>
  );
};
